import { el, list } from 'redom';

import Track from './track';

import './index.scss';

class PlayerTracks {

  constructor(videoBuilder) {

    this.videoBuilder = videoBuilder;

    this.tracksView = list('.video-builder-tracks.hide-scrollbar', Track, 'id', this);

    this.tracksView.update(this.videoBuilder.playerProperties.tracks);

    this.el = this.tracksView;

  }

  update() {

    this.tracksView.update(this.videoBuilder.playerProperties.tracks);

  }

}

export default PlayerTracks;